import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { QuestionDto } from '../dto/justino/question.dto';
import { ParameterDto } from '../dto/justino/parameter.dto';
import { ResEncuestaDto } from '../dto/justino/res-encuesta.dto';
import { Constants } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  private apiUrl = `${environment.justinoApiUrl}/api/questions`;
  private parametersUrl = `${environment.justinoApiUrl}/api/parameters`;
  private encuestasUrl = `${environment.justinoApiUrl}/api/encuestas`;

  constructor(private http: HttpClient) { }

  getHeaders() {
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN) ?? '';
    return { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
  }

  getAllQuestions(plantilla: string): Observable<QuestionDto[]> {
    return this.http.get<QuestionDto[]>(this.apiUrl + '/' + plantilla, { headers: this.getHeaders() });
  }

  setQuestions(questions: QuestionDto[]): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/', questions, { headers: this.getHeaders() });
  }

  getParameterByName(parameterName: string): Observable<ParameterDto> {
    const url = `${this.parametersUrl}/name/${parameterName}`;
    return this.http.get<ParameterDto>(url, { headers: this.getHeaders() });
  }

  saveResults(encuesta: ResEncuestaDto): Observable<any> {
    return this.http.post<any>(this.encuestasUrl + '/', encuesta, { headers: this.getHeaders() });
  }
}
